import BaseObject from '../../base/base_object';

interface NetEntExtendParams {
    netEntExtendObject: any
}

export default class NetEntExtend extends BaseObject {
    static CLASS = 'NetEntExtend';

    private _netEntExtendObject = null;
    init(params: NetEntExtendParams) {
        super.init(params);
        this._netEntExtendObject = params.netEntExtendObject;
    }

    resize(width: number, height: number): void {
        if(this._netEntExtendObject) {
            this._netEntExtendObject.resize(width, height);
        }

    }
    addEventListener(eventName: string, callBack: Function): void {
        if(this._netEntExtendObject) {
            this._netEntExtendObject.addEventListener(eventName, callBack);
        }

    }

    removeEventListener(eventName: string, callBack: Function): void {
        if(this._netEntExtendObject) {
            this._netEntExtendObject.removeEventListener(eventName, callBack);
        }
    }

    stopAutoplay(): void {
        if(this._netEntExtendObject) {
            this._netEntExtendObject.call("stopAutoplay", [], () => { }, (err) => {
                if(err && err.code !== 12) { // Netent sends error code 12 when we call stop autoplay and there is no autoplay in progress
                    this.logger.error('NetEnt stopAutoplay failed!', err);
                }
            });
        }
    }
}